import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-96" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pt-4 font-light font-roboto text-blue-800 text-2xl" }, "Sisselogimine", -1)
const _hoisted_3 = { class: "mt-2 max-w-3xl text-lg text-gray-500" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Teie viimasest sisselogimisest on palju aega möödas. Turvalisuse huvides palun sisestage parool uuesti!")
const _hoisted_5 = { class: "sm:mx-auto sm:w-full sm:max-w-md" }
const _hoisted_6 = { class: "bg-white pt-4 px-4 sm:px-10" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block text-base font-normal text-gray-800"
}, " Parool ", -1)
const _hoisted_8 = { class: "mt-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-base font-normal text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
  }, " Logi sisse ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalWrapper = _resolveComponent("ModalWrapper")!

  return (_openBlock(), _createBlock(_Teleport, { to: "#modal-wrapper" }, [
    _createVNode(_component_ModalWrapper, {
      open: _ctx.isOpen,
      onOnclose: _ctx.onClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("p", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _hoisted_4
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("form", {
                class: "space-y-6",
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onLoginAttempt && _ctx.onLoginAttempt(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", null, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      id: "password",
                      name: "password",
                      type: "password",
                      autocomplete: "current-password",
                      required: "",
                      class: "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:ring-0 focus:border-blue-500 focus:outline-none sm:text-sm",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.password]
                    ])
                  ])
                ]),
                _hoisted_9
              ], 32)
            ])
          ])
        ])
      ]),
      _: 3
    }, 8, ["open", "onOnclose"])
  ]))
}